import ButtonLink from 'components/ButtonLink';

const Phone = ({ className = '', number, text = number }) => {
    const href = `tel:+${number}`;

    return <ButtonLink className={className} href={href} text={text} />;
};

export default Phone;
